import { css } from '@linaria/core';

/**
 * Used for short, important text or numerals, like brand content.
 */
export const display: string = css`
  @layer cb {
    font: var(--cb-font-weight-bold) var(--cb-font-size-title-xxlarge) /
      var(--cb-font-leading-small) var(--cb-font-family-brand);
    letter-spacing: var(--cb-font-tracking-medium);
    font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
  }
`;

/**
 * Used for page headings, like profile or settings.
 */
export const largeTitle: string = css`
  @layer cb {
    font: var(--cb-font-weight-bold) var(--cb-font-size-title-xlarge) / var(--cb-font-leading-small)
      var(--cb-font-family-brand);
    letter-spacing: var(--cb-font-tracking-medium);
    font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
  }
`;

/**
 * Used for page headings, like profile or settings.
 */
export const title: string = css`
  @layer cb {
    font: var(--cb-font-weight-bold) var(--cb-font-size-title-large) / var(--cb-font-leading-small)
      var(--cb-font-family-brand);
    letter-spacing: var(--cb-font-tracking-medium);
    font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
  }
`;

/**
 * Used to introduce new sections or in large components, like modals.
 */
export const headline: string = css`
  @layer cb {
    font: var(--cb-font-weight-semibold) var(--cb-font-size-title-medium) /
      var(--cb-font-leading-small) var(--cb-font-family-brand);
    letter-spacing: var(--cb-font-tracking-medium);
    font-feature-settings: var(--cb-font-family-brand-font-feature-settings);
  }
`;

/**
 * Used to introduce subsections or in small components like banners.
 */
export const subheadline: string = css`
  @layer cb {
    font: var(--cb-font-weight-bold) var(--cb-font-size-body-medium) / var(--cb-font-leading-small)
      var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  }
`;

/**
 * Default size for reading text.
 */
export const body: string = css`
  @layer cb {
    font: var(--cb-font-weight-regular) var(--cb-font-size-body-medium) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  }
`;

/**
 * Used to style interactive labels or to emphasise text. It pairs with Body.
 */
export const bodyLabel: string = css`
  @layer cb {
    font: var(--cb-font-weight-semibold) var(--cb-font-size-body-medium) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  }
`;

/**
 * Use for text links inside a paragraph or for standalone text. It pairs with Body.
 */
export const bodyLink: string = css`
  @layer cb {
    font: var(--cb-font-weight-semibold) var(--cb-font-size-body-medium) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
    text-decoration: underline;
  }
`;

/**
 * Used for short paragraph or helper text, like captions or metadata.
 */
export const caption: string = css`
  @layer cb {
    font: var(--cb-font-weight-regular) var(--cb-font-size-body-small) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  }
`;

/**
 * Used to style interactive labels or to emphasise text. It pairs with Caption.
 */
export const captionLabel: string = css`
  @layer cb {
    font: var(--cb-font-weight-semibold) var(--cb-font-size-body-small) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  }
`;

/**
 * Use for text links inside a paragraph or for standalone text. It pairs with Caption.
 */
export const captionLink: string = css`
  @layer cb {
    font: var(--cb-font-weight-semibold) var(--cb-font-size-body-small) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
    text-decoration: underline;
  }
`;

/**
 * Used for helper text or legal copy, like text that appears below an input field.
 */
export const footnote: string = css`
  @layer cb {
    font: var(--cb-font-weight-regular) var(--cb-font-size-footnote-medium) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  }
`;

/**
 * Used to style interactive labels or to emphasise text. It pairs with Footnote.
 */
export const footnoteLabel: string = css`
  @layer cb {
    font: var(--cb-font-weight-semibold) var(--cb-font-size-footnote-medium) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
  }
`;

/**
 * Use for text links inside a paragraph or for standalone text. It pairs with Footnote.
 */
export const footnoteLink: string = css`
  @layer cb {
    font: var(--cb-font-weight-semibold) var(--cb-font-size-footnote-medium) /
      var(--cb-font-leading-medium) var(--cb-font-family-sans);
    letter-spacing: var(--cb-font-tracking-medium);
    text-decoration: underline;
  }
`;
